import {getDirectoryStatusTextKey} from '../../states/company/directory-integration/directory-integration.functions'

export class Controller {

    $onChanges() {
        this.iconClass = ({
            'saaspass-cloud-directory': 'fa fa-database',
            AD: 'fa-solid fa-audio-description',
            AZURE: 'fa-solid fa-diamond',
            LDAP: 'fa-solid fa-sharp fa-l',
            SCIM: 'fa-solid fa-rotate',
        })[this.directoryDto ? this.directoryDto.type || 'AD' : 'saaspass-cloud-directory'];
    }

    getStatusKey() {
        return getDirectoryStatusTextKey(this.directoryDto.statusDto.ongoingOperation);
    }
}



// WEBPACK FOOTER //
// ./src/portal/components/sp-directory-label/sp-directory-label.controller.js